export interface Account {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  company: string;
  country: string;
  state: string;
  address: string;
  phone: string;
  language: string;
  industry: string[];
  registeredAt: string;
  role: string;
  role_id: number;
  roleLevel: number;
  permissions: string[];
  checkedPiiPolicy: boolean;
}

export const defaultAccount: Account = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  company: '',
  country: '',
  state: '',
  address: '',
  phone: '',
  language: '',
  industry: [],
  registeredAt: '',
  role: '',
  role_id: 0,
  roleLevel: 0,
  permissions: [],
  checkedPiiPolicy: false,
};
